"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const mobx_react_1 = require("mobx-react");
const contexts_1 = require("@App/contexts");
const RoyaltiesAnnualStatementsRow_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderRoyaltiesAnnualStatements/RoyaltiesAnnualStatementsTable/RoyaltiesAnnualStatementsRow"));
const RoyaltiesAnnualStatementsTable = (props) => {
    const { statementsStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { sendTSVRequest } = props;
    const royalties = statementsStore.royalties;
    return (react_1.default.createElement("div", { className: "royalties-table annual-statements-table" },
        react_1.default.createElement("table", null,
            react_1.default.createElement("tbody", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", null, "Publisher Number"),
                    react_1.default.createElement("th", null, "Payee Name"),
                    react_1.default.createElement("th", null, "Opening Balance"),
                    react_1.default.createElement("th", null, "Royalties in Period"),
                    react_1.default.createElement("th", null, "Payable Amount"),
                    react_1.default.createElement("th", null, "Amount Paid"),
                    react_1.default.createElement("th", null, "Closing Balance"),
                    react_1.default.createElement("th", null, "Payee Activity"),
                    react_1.default.createElement("th", null, "Statements")),
                royalties &&
                    (royalties === null || royalties === void 0 ? void 0 : royalties.length) > 0 &&
                    royalties.map((row, idx) => (react_1.default.createElement(RoyaltiesAnnualStatementsRow_1.default, { sendTSVRequest: sendTSVRequest, payeeRoyalties: row, key: idx }))))),
        (royalties === null || royalties === void 0 ? void 0 : royalties.length) === 0 && (react_1.default.createElement("div", { className: 'no-statements-message' },
            "No ",
            react_1.default.createElement("strong", null, "Annual Statement"),
            " available"))));
};
exports.default = (0, mobx_react_1.observer)(RoyaltiesAnnualStatementsTable);
